import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbThron: BowlBlock = withIntegration(options.slug.llmKbThron, [
  {
    name: 'organizationName',
    type: 'withText',
    required: true,
  },
  {
    name: 'attributeFields',
    type: 'text',
    hasMany: true,
  },
  {
    name: 'clientId',
    type: 'withText',
    required: true,
  },
  {
    name: 'clientSecret',
    type: 'withText',
    required: true,
  },
]);
